export default __webpack_public_path__ + "static/Sam-255332ccc0b0f9ba33011526d8812386.png";